import React from 'react'

const tagContext = React.createContext({});

export { tagContext }
